export default class Alert {
	constructor(settings, content)
	{
		this._parent = settings.parentElement
		this._position = settings.position
		this._disableElement = settings.disableElement
		this._type = settings.type
		this._heading = content.heading
		this._body = content.body
		// this.alert = document.querySelector('.jsAlert');

		this.init();
	}

	show()
	{

		if (this._disableElement)
		{
			document.querySelector(this._disableElement).disabled = true;
		}
		if (this._position)
		{
			this.alert.classList.add('-' + this._position);
		}
		if (this._type)
		{
			this.alert.classList.add('-' + this._type);
		}

		this.heading(this._heading);
		this.body(this._body);

		this.alert.classList.remove('-hidden');
	}

	hide()
	{
		if (this._disableElement)
		{
			document.querySelector(this._disableElement).disabled = false;
		}
		this.alert.classList.add('-hidden')
	}

	heading(heading)
	{
		this.alert.querySelector('.jsAlertHeading').innerHTML = heading;
	}

	body(body)
	{
		this.alert.querySelector('.jsAlertBody').innerHTML = body;
	}

	init()
	{
		this.alert = document.querySelector('.jsAlert');

		// Close Button(s)
		this._closeBtns = this.alert.querySelectorAll('.jsAlertClose');
		this._closeBtns.forEach(closeBtn => {
			closeBtn.addEventListener('click', () => { this.hide() } );
		});
	}
}